//function to parse wav files
import { cloneDeep } from "lodash";
import { getSequence } from "./parseUtil";

export const BIN_TYPE_LAPTOP = "BIN_TYPE_LAPTOP";
export const BIN_TYPE_APM3G = "BIN_TYPE_APM3G";
export const BIN_TYPE_APM4G = "BIN_TYPE_APM4G";

const initialFileData = {
  fileType: null,
  sampleRate: null,
  bitsPerSample: null,
  float: false,
  channelNumber: null,
  display: "unknown",
};

/**
 * Parses the wave file and returns an object with it's properties
 * @param file
 * @returns {Promise<void>}
 */
export const parseWAVfile = async (file) => {
  const fileData = cloneDeep(initialFileData);
  fileData.fileType = "WAV";
  fileData.numberOfChannels = getSequence(fileData.fileType, file.name);

  //We don't need to read and decode the audio data. We just need some of the header.
  //we need to have enough data to make sure we filter out invalid segments like "junk".
  const blob = file.slice(0, 1024);

  const view = new DataView(await blob.arrayBuffer());

  //Find fmt segment
  let index = 0;
  for (index = 0; index < 1020; index++) {
    //Find 'fmt'
    if (
      view.getUint8(index) === 0x66 &&
      view.getUint8(index + 1) === 0x6d &&
      view.getUint8(index + 2) === 0x74
    ) {
      console.log("[parseWavFile] fmt header found at position: " + index);
      break;
    }
  }

  if (index >= 1020) {
    console.error("[parseWavFile] Invalid Header. Could not find fmt block");
    return cloneDeep(initialFileData);
  }

  console.log(">>>>>>>>>>>>>>>>>> " + index);

  fileData.channels = view.getUint16(10 + index, true);
  fileData.sampleRate = view.getUint32(12 + index, true);
  fileData.bitsPerSample = view.getUint16(22 + index, true);

  const audioFormat = view.getUint16(8 + index, true);

  if (audioFormat === 3) {
    console.log(" float");
    fileData.float = true;
    fileData.display = fileData.bitsPerSample + " bit float";
  } else {
    fileData.display = fileData.bitsPerSample + " bit integer";
    console.log(" integer");
    fileData.display = fileData.bitsPerSample + " bit";
  }

  console.log("[parseWAVFile] FileData: ", fileData);
  return fileData;
};

export const parseInt16File = (file) => {
  const fileData = cloneDeep(initialFileData);
  fileData.display = "16 bitrate signed";
  fileData.numberOfChannels = undefined;
  fileData.sampleRate = 16537.5;
  fileData.bitsPerSample = 16;
  fileData.fileType = "INT16";
  fileData.float = false;
  console.log("[parseInt16] FileData: ", fileData);
  return fileData;
};

//function to parse bin files
export const parseBINFile = (file, binType) => {
  const fileData = cloneDeep(initialFileData);
  fileData.fileType = "BIN";
  fileData.display = "32 bit signed int";
  fileData.bitsPerSample = 32;
  fileData.float = false;

  switch (binType) {
    case BIN_TYPE_LAPTOP: {
      fileData.sampleRate = 24000;
      fileData.numberOfChannels = 16;
      break;
    }

    case BIN_TYPE_APM3G:
    case BIN_TYPE_APM4G:
    default: {
      fileData.numberOfChannels = 8;
      fileData.sampleRate = 48000;
      break;
    }
  }
  return fileData;
};
